<template>
  <div id="company">
    <div class="table-add">
      <el-button @click="updateCompany(-1)" size="medium" type="primary"
        >新增公司</el-button
      >
    </div>
    <div class="table-container">
      <el-table :data="companyList" stripe style="width: 100%">
        <el-table-column prop="id" label="公司ID">
          <template slot-scope="scope">
            <span>{{ scope.row.id }} </span>
            <el-tooltip
              effect="dark"
              :content="'复制员工端登录地址: ' + getCompanyUrl(scope.row.id)"
              placement="top-start"
            >
              <el-button
                type="primary"
                icon="el-icon-document-copy"
                size="mini"
                circle
                plain
                @click="copyCompanyUrl(scope.row.id)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="公司名称"> </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              size="small"
              @click="updateCompany(scope.row.id)"
              type="primary"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          small
          layout="prev, pager, next"
          :total="total_count"
          :current-page="page"
          @current-change="getCompanyList"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  managerCompanyList,
  managerCompanyAdd,
  managerCompanyUpdate,
} from '@/api/manager'
import { mapGetters } from 'vuex'
export default {
  name: 'company',
  components: {},
  data() {
    return {
      companyList: [],
      page: 0,
      total_count: 0,
    }
  },
  mounted() {
    this.getCompanyList()
  },
  computed: {
    ...mapGetters(['companyName']),
  },
  methods: {
    getCompanyUrl(_id) {
      return window.location.host + '/login?id=' + _id
    },
    copyCompanyUrl(_id) {
      let clipBoardContent = this.getCompanyUrl(_id)
      document.addEventListener('copy', save) // 监听浏览器copy事件
      document.execCommand('copy') // 执行copy事件，这时监听函数会执行save函数。
      document.removeEventListener('copy', save) // 移除copy事件

      // 保存方法
      function save(e) {
        e.clipboardData.setData('text/plain', clipBoardContent) // 剪贴板内容设置
        e.preventDefault()
      }

      this.$message({
        type: 'success',
        message: '复制成功',
      })
    },
    async getCompanyList(_page = 1) {
      this.page = _page
      let { code, result } = await managerCompanyList({ page: _page })
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.companyList = result.list
        this.total_count = result.total_count
      }
    },
    updateCompany(_id) {
      this.$prompt('请输入' + _id < 0 ? '新增' : '新的' + '公司名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async ({ value }) => {
          if (_id < 0) {
            var { code, msg } = await managerCompanyAdd({ name: value })
          } else {
            var { code, msg } = await managerCompanyUpdate({
              id: _id,
              name: value,
            })
          }
          if (code === this.CONFIG.CODE_SUCCESS) {
            this.getCompanyList(this.page)
            this.$message({
              type: 'success',
              message: msg,
            })
          }
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="less" scoped>
.table-container {
  width: 100%;
}
.table-add {
  margin: 7px 0 15px 0;
}
.table-container {
  padding: 8px;
  background: #fff;
  border-radius: 5px;
}
.table-page {
  margin-top: 15px;
  text-align: center;
}
</style>
